import { compose, withProps } from 'recompose'
import { connect } from 'react-redux'

import {
  selectAmount,
  selectType,
  selectRate,
  selectMonthlyPayment,
  selectAdjustable,
  selectArmYearsInitial,
  selectCreatedAt,
  selectExpiresAt,
} from '../../../../../../../store/selectors/prequal'
import { selectLoanOfficerPhotoUri } from '../../../../../../../store/selectors/loanOfficer'

const PrequalContainer = compose(
  connect((state, { data }) => ({
    loanOfficerAvatarUri: selectLoanOfficerPhotoUri(state),
    amount: selectAmount(data),
    adjustable: selectAdjustable(data),
    armYearsInitial: selectArmYearsInitial(data),
    loanType: selectType(data),
    fromDate: selectCreatedAt(data),
    expiresAt: selectExpiresAt(data),
    rate: selectRate(data),
    payment: selectMonthlyPayment(data),
  })),
  withProps(({ expiresAt }) => ({
    expirationDate: expiresAt ? expiresAt.format('MMMM DD, YYYY') : '',
  }))
)

export default PrequalContainer
